import { useEffect } from 'react';
import DesignerApp from './DesignerApp';
import { useEditorStore } from './state/editorStore';

export default function OrderDesignerBridge({
  order,
  design,
}: {
  order: any;
  design?: any;
}) {
  useEffect(() => {
    const store = useEditorStore.getState();
    const orderId = order?.id;
    if (orderId) store.setOrderId(orderId);

    // 优先级 1：本地按订单保存的存档（最新编辑状态）
    if (orderId && store.loadFromLocal(orderId)) {
      return;
    }

    // 优先级 2：后端已有设计快照
    const editorProject = design?.preview_json?.editor_project_json;
    if (editorProject) {
      try {
        store.loadProject(JSON.stringify(editorProject));
        return;
      } catch (error) {
        console.error('Failed to load designer snapshot:', error);
      }
    }

    // 优先级 3：从订单尺寸新建
    const length = Number(order?.length || 1200);
    const width = Number(order?.width || 800);
    const height = Number(order?.height || 600);
    store.setInnerSize({ length, width, height });
  }, [order?.id, order?.length, order?.width, order?.height, design?.preview_json?.editor_project_json]);

  return <DesignerApp embedded />;
}
